<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header"><i class="fa fa-user fa-fw"></i>Meu Perfil</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <br />
      <div v-if="msg">
          <div class="alert" v-bind:class="[msgAlert ? 'alert-info': 'alert-danger']">
            <span><i class="fa fa-exclamation fa-fw"></i><strong>{{msg}}</strong></span>
          </div>
        </div>
      <form v-if="addButton.seeForm" role="form" @submit.prevent="alterPass()">
        <input v-model="user.id" type="hidden"/>
        <div class="col-lg-10">
          <div class="col-lg-6">
            <div class="form-group">
              <label>Nome</label>
              <input class="form-control" v-model="user.nome"/>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Email</label>
              <input class="form-control" v-model="user.email"/>
            </div>
          </div>
        </div>
        
        <div class="col-lg-10">
          <div class="col-lg-6">
            <div class="form-group">
              <label>Nova senha</label>
              <input class="form-control" v-bind:type="[clickEye ? 'password': 'text']" v-model="user.newSenha"/>
              <a @click="togglePass()" class="olho"><i v-bind:class="[clickEye ? 'fa fa-eye-slash': 'fa fa-eye']"></i></a>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Confirmar senha</label>
              <input class="form-control" v-bind:type="[clickEye ? 'password': 'text']" v-model="user.confirmSenha"/>
            </div>
          </div>
        </div>
        
        <button @click="alterPass()" type="submit" class="btn btn-block btn-info">Salvar</button>
      </form>
        
      <p>&nbsp</p>
      <div>
        <a @click="addButton.seeForm = !addButton.seeForm" @click.stop="edit(user.id)" class="btn btn-sm btn-primary">
          <i class="fa fa-pencil fa-fw"></i>
        </a>
          <table class="table table-bordered table-striped table-hover">
            <tbody>
              <tr>
                <td>#</td>
                <td>{{user.id}}</td>
              </tr>
              <tr>
                <td>Nome</td>
                <td>{{user.nome}}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{user.email}}</td>
              </tr>
              <tr>
                <td>Setor</td>
                <td>{{user.sectorId}} - {{user.setor}}</td>
              </tr>
              <tr>
                <td>Perfil de Acesso</td>
                <td>{{lang.t(user.profiles[0].name)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      <br />      
    </div>
  </div>
</template>

<script>

import storage from '../../mixins/storage'
import lang from "../../mixins/pt-br";

export default {
  name: "MyProfile",
  inject: ["loading"],
  data() {
    return {
      lang,
      addButton: { seeForm: false },
      user: { nome: "", email: "", senha: "", newSenha: "", confirmSenha: ""},      
      showByIndex: null,
      msg: null,
      msgAlert: false,
      clickEye: true,
    };
  },
   mounted() {
    this.loading.value = true
    this.$http.get(`/auth/info/${storage.methods.getToken()}`).then((response) => {
      this.user = response.data;
    setTimeout(()=> this.loading.value = false, 1000)
    }).catch(error => console.log(error));          
  },
  methods:{
    edit(id) {
      this.loading.value = true;
      this.$http
        .get(`user/${id}`)
        .then((response) => {
          this.addButton.seeForm = true;
          this.user = response.data;
          this.msg = null;
        })
        .catch((error) => {
          console.log(error);
        });
      setTimeout(() => (this.loading.value = false), 1000);
    },
    alterPass(){
      if(this.user.confirmSenha === this.user.newSenha){
        this.loading.value = true;
        this.$http.post(`/user/update-password?token=${storage.methods.getToken()}&newPassword=${this.user.newSenha}`)
          .then(response => {
            this.user.newSenha = "";
            this.user.confirmSenha = "";
            this.msgAlert = true,
            this.msg ='sua senha foi alerada com sucesso'
            this.addButton.seeForm = false;
            this.$router.push('/admin/my-profile')

          })
          .catch((error) => {
            console.log(error)
          })
          .finally( () => setTimeout(() => this.loading.value = false, 300))
      }else{
        this.msgAlert = false,
        this.msg ='as senhas não conferem, por favor repita!'
      }
    },
    togglePass(){
      this.clickEye = !this.clickEye;
      console.log(this.clickEye)     
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/MyProfile.vue